export enum SubscriptionRoutes {
  base = 'subscription',
  list = 'subscription-list',
  generate = 'subscription-generate',
  view = 'subscription-view',
  transactions = 'subscription-transactions'
}
